import type { Voice } from "../types/voice";
import { TFunction } from "i18next";

/**
 * Google音声のラベルを生成する
 * @param gender 性別
 * @param name 音声名
 * @param t 翻訳関数
 * @returns フォーマット済みのラベル
 */
export const googleVoiceLabel = (gender: string, name: string | undefined, t: TFunction) => {
  if (!name) return "";
  return "Google \n" + name + " - " + t(`voice.gender.${gender}`);
};

/**
 * OpenAI音声のラベルを生成する
 * @param name 音声名
 * @param gender 性別
 * @param t 翻訳関数
 * @returns フォーマット済みのラベル
 */
export const openaiVoiceLabel = (name: string, gender: string, t: TFunction) => {
  return "OpenAI \n" + t(`voice.openaiVoiceLabel.${name}`) + " - " + t(`voice.gender.${gender}`);
};

/**
 * Minimax音声のラベルを生成する
 * @param name 音声名
 * @param t 翻訳関数
 * @returns フォーマット済みのラベル
 */
export const minimaxVoiceLabel = (name: string, t: TFunction) => {
  return "Minimax \n" + t(`voice.minimaxVoiceLabel.${name}`) || name;
};

/**
 * 音声プロバイダー別にラベルを生成する
 * @param voice 音声オブジェクト
 * @param t 翻訳関数
 * @param expanded 展開表示するかどうか（オプション）
 * @returns フォーマット済みのラベル
 */
export const getProviderVoiceLabel = (voice: Voice, t: TFunction, expanded = true) => {
  let label = "";

  if (voice.provider === "openai") {
    label = openaiVoiceLabel(voice.voice_name, voice.gender, t);
  } else if (voice.provider === "google") {
    label = googleVoiceLabel(voice.gender, voice.voice_name, t) || "";
  } else if (voice.provider === "minimax") {
    label = minimaxVoiceLabel(voice.voice_name, t);
  }

  // 省略表示（非展開時）
  if (!expanded && label) {
    return label.slice(0, 6) + (label.length > 6 ? "..." : "");
  }

  return label;
};
